import { FC } from 'react'
import { Avatar, Box, Button, Flex, Text } from '@mantine/core'

const IdentityRow: FC<{ label: string; email: string }> = ({ label, email }) => (
  <Flex align="center" gap={12} p={12} bg="#f8fafc" style={{ borderRadius: 10 }}>
    <Avatar size={32} radius="xl" color="scBlue" aria-hidden="true">{(email.trim()[0] || '?').toUpperCase()}</Avatar>
    <Box miw={0}>
      <Text size="xs" c="#6B6F76">{label}</Text>
      <Text size="sm" fw={600} c="#101828" style={{ overflowWrap: 'anywhere' }}>{email}</Text>
    </Box>
  </Flex>
)

const WrongAccountScreen: FC<{
  company: string
  invitedEmail: string
  signedInEmail: string
  busy?: boolean
  error?: string
  onSignOut: () => void
  onCancel: () => void
}> = ({ company, invitedEmail, signedInEmail, busy, error, onSignOut, onCancel }) => (
  <>
    <Text size="28px" fw={700} c="#101828" mb={8}>This invite is for a different account</Text>
    <Text size="md" c="#4b5563" mb={20}>
      You've been invited to join <strong>{company}</strong>. Sign out to accept it.
    </Text>
    <Flex direction="column" gap={8} mb={24}>
      <IdentityRow label="Invite sent to" email={invitedEmail} />
      <IdentityRow label="Signed in as" email={signedInEmail} />
    </Flex>
    <Button fullWidth color="scBlue" size="md" onClick={onSignOut} loading={busy} disabled={busy}>
      Sign out and continue
    </Button>
    {error && <Text size="sm" c="red" mt="sm">{error}</Text>}
    <Button fullWidth variant="default" size="md" mt={10} onClick={onCancel} disabled={busy}>
      Cancel
    </Button>
    <Text size="xs" c="#9ca3af" ta="center" mt="md">Tip: you can also open the invite link in a private window.</Text>
  </>
)

export default WrongAccountScreen
